import { render, staticRenderFns } from "./QualityControlReport.vue?vue&type=template&id=37658cf1&scoped=true"
import script from "./QualityControlReport.vue?vue&type=script&lang=js"
export * from "./QualityControlReport.vue?vue&type=script&lang=js"
import style0 from "./QualityControlReport.vue?vue&type=style&index=0&id=37658cf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37658cf1",
  null
  
)

export default component.exports